export { getCountries as default } from 'libphonenumber-js/core'